'use strict';

var PRICE_MULTIPLIER = 100;

module.exports = [{ display: '$1-$50', value: { $gte: 1 * PRICE_MULTIPLIER, $lte: 50 * PRICE_MULTIPLIER } }, {
  display: '$51-$75',
  value: { $gte: 50 * PRICE_MULTIPLIER + 1, $lte: 75 * PRICE_MULTIPLIER }
}, {
  display: '$76-$100',
  value: { $gte: 75 * PRICE_MULTIPLIER + 1, $lte: 100 * PRICE_MULTIPLIER }
}, {
  display: '$100-$150',
  value: { $gte: 100 * PRICE_MULTIPLIER + 1, $lte: 150 * PRICE_MULTIPLIER }
}, {
  display: '$150+',
  value: { $gte: 150 * PRICE_MULTIPLIER + 1 }
}];